import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import userSVG from "../svg/user.svg";
import {
  typesOfTeacher,
  indianStates,
  countries,
  countryCodeOptions,
  optionsFacilitiesForInternationals,
} from "../dropdownsData";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
  FormHelperText,
  Box,
  FormGroup,
  Checkbox,
} from "@mui/material";

const PersonalDetails = ({ control, errors, trigger }) => {
  const [typeOfTeacherSelected, setTypeOfTeacherSelected] = useState(null);
  const [allRows, setAllRows] = useState("");
  const [noteTitle, setNoteTitle] = useState("");
  const [noteFirstText, seNoteFirstText] = useState("");
  const [noteSecondText, setNoteSecondText] = useState("");
  const [noteBeforeLink, setNoteBeforeLink] = useState("");
  const [linkText, setLinkText] = useState("");
  const [linkUrl, setLinkUrl] = useState("");

  const handleTypeOfTeacherSelectedChange = (event) => {
    setTypeOfTeacherSelected(event.target.value);
  };

  useEffect(() => {
    fetch("/api/google-sheet-data/ReadData")
      .then((response) => response.json())
      .then((res) => {
        setAllRows(res.data);
      })
      .catch((error) => {
        console.error("Error fetching data from server:", error);
      });
  }, []);

  useEffect(() => {
    if (typeOfTeacherSelected && allRows) {
      let rowIndex;
      switch (typeOfTeacherSelected) {
        case "State Teachers Coordinator":
          rowIndex = 1;
          break;
        case "Ashram Non-resident Teacher":
          rowIndex = 2;
          break;
        case "International Teacher":
          rowIndex = 3;
          break;
        case "Other Organizer":
          rowIndex = 4;
          break;
        default:
          rowIndex = 1;
          break;
      }
      const entireRow = allRows[rowIndex];
      setNoteTitle(entireRow[1]);
      seNoteFirstText(entireRow[2]);
      setNoteSecondText(entireRow[3]);
      setNoteBeforeLink(entireRow[4]);
      setLinkText(entireRow[5]);
      setLinkUrl(entireRow[6]);
    }
  }, [typeOfTeacherSelected, allRows]);

  return (
    <div className="main-card">
      <div className="card-title-box">
        <img className="svg-in-card-title" src={userSVG} alt="user" />
        <div className="card-title">Requestor Details</div>
      </div>
      <div className="sub-card">
        <div className="mb-1">
          <Controller
            render={({ field }) => (
              <TextField
                {...field}
                error={Boolean(errors.fullName)}
                helperText={errors.fullName ? errors.fullName.message : null}
                label={
                  <div>
                    Name <span className="text-orange">*</span>
                  </div>
                }
                className="w-full"
                defaultValue={""}
              />
            )}
            name="fullName"
            control={control}
            rules={{
              required: "Full Name is required",
              maxLength: {
                value: 30,
                message: "Full  name cannot exceed 30 characters",
              },
            }}
          />
        </div>

        <div className="flex flex-col sm:flex-row mb-1 w-full justify-between">
          <div className="sm:mr-2 w-full mb-1 sm:mb-0">
            <Controller
              render={({ field }) => (
                <TextField
                  {...field}
                  error={Boolean(errors.email)}
                  helperText={errors.email ? errors.email.message : null}
                  label={
                    <div>
                      Email <span className="text-orange">*</span>
                    </div>
                  }
                  className="w-full"
                  onBlur={async () => {
                    await trigger(`email`); // Trigger validation on blur
                    field.onBlur(); // Ensure onBlur event is propagated
                  }}
                />
              )}
              name="email"
              control={control}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Invalid email format",
                },
              }}
            />
          </div>
          <div className="flex w-full">
            <div className="mr-0-5 w-10">
              <Controller
                name="countryCode"
                control={control}
                defaultValue={countryCodeOptions.find(
                  (option) => option.code === "91"
                )}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    id="country-select"
                    options={countryCodeOptions}
                    onChange={(event, value) => field.onChange(value)}
                    autoHighlight
                    renderOption={(props, option) => {
                      return (
                        <Box
                          component="li"
                          sx={{ "& > img": { mr: 0.5, flexShrink: 0 } }}
                          {...props}
                        >
                          <img
                            loading="lazy"
                            width="20"
                            srcSet={`https://flagcdn.com/w40/${option.country.toLowerCase()}.png 2x`}
                            src={`https://flagcdn.com/w20/${option.country.toLowerCase()}.png`}
                            alt=""
                          />
                          {option.label}
                        </Box>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={Boolean(errors.countryCode)}
                        helperText={
                          errors.countryCode ? errors.countryCode.message : null
                        }
                        label={
                          <div>
                            Code <span className="text-orange">*</span>
                          </div>
                        }
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password", // deshabilitar autocompletar y autocompletar
                        }}
                      />
                    )}
                  />
                )}
                rules={{
                  required: "Code is required",
                }}
              />
            </div>
            <Controller
              render={({ field }) => (
                <TextField
                  {...field}
                  error={Boolean(errors.mobileNumber)}
                  helperText={
                    errors.mobileNumber ? errors.mobileNumber.message : null
                  }
                  label={
                    <div>
                      Mobile Number <span className="text-orange">*</span>
                    </div>
                  }
                  className="w-full"
                />
              )}
              name="mobileNumber"
              control={control}
              rules={{
                required: "Mobile Number is required",
                pattern: {
                  value: /^[0-9]*$/,
                  message: "Please enter only numeric characters.",
                },
                maxLength: {
                  value: 20,
                  message: "Mobile number cannot exceed 20 characters",
                },
              }}
            />
          </div>
        </div>
        <div className="mb-1">
          <div className="my-0-5">
            You are...<span className="text-orange">*</span>
          </div>
          <Controller
            render={({ field }) => (
              <div>
                <RadioGroup
                  {...field}
                  value={typeOfTeacherSelected}
                  onChange={(type) => {
                    field.onChange(type);
                    handleTypeOfTeacherSelectedChange(type);
                  }}
                >
                  <div className="flex flex-col sm:flex-row sm:items-center">
                    {typesOfTeacher.map((type, index) => (
                      <FormControlLabel
                        key={index}
                        value={type}
                        control={<Radio />}
                        label={type}
                      />
                    ))}
                  </div>
                </RadioGroup>
                {errors.requestorType && (
                  <FormHelperText error>
                    {errors.requestorType.message}
                  </FormHelperText>
                )}
              </div>
            )}
            name="requestorType"
            control={control}
            rules={{
              required: "Teacher type is required",
            }}
          />
        </div>
        {typeOfTeacherSelected && (
          <>
            {noteTitle && <div className="mb-0-5 text-bold">{noteTitle}</div>}
            {noteFirstText && (
              <div className="mb-0-5 text-sm">{noteFirstText}</div>
            )}
            {noteSecondText && (
              <div className="mb-0-5 text-sm">{noteSecondText}</div>
            )}

            {(noteBeforeLink || linkText || linkUrl) && (
              <div className="flex items-center mb-0-5 text-sm">
                {noteBeforeLink && (
                  <div className="text-sm mr-0-25">{noteBeforeLink}</div>
                )}
                {linkUrl && (
                  <a
                    className="text-sm underline text-orange"
                    href={linkUrl}
                    target="blank"
                  >
                    {linkText || linkUrl}
                  </a>
                )}
              </div>
            )}
          </>
        )}
        <div className="mb-1">
          <Controller
            render={({ field }) => (
              <FormControl fullWidth error={Boolean(errors.stateOrCountry)}>
                <InputLabel id="stateOrCountry-label">
                  {typeOfTeacherSelected === "International Teacher"
                    ? "Country"
                    : "State"}{" "}
                  <span className="text-orange">*</span>
                </InputLabel>
                <Select
                  labelId="stateOrCountry-label"
                  id="stateOrCountry"
                  label={
                    <div>
                      {typeOfTeacherSelected === "International Teacher"
                        ? "Country"
                        : "State"}{" "}
                      <span className="text-orange">*</span>
                    </div>
                  }
                  {...field}
                >
                  {typeOfTeacherSelected === "International Teacher"
                    ? countries.map((country, index) => (
                        <MenuItem key={index} value={country}>
                          {country}
                        </MenuItem>
                      ))
                    : indianStates.map((state, index) => (
                        <MenuItem key={index} value={state}>
                          {state}
                        </MenuItem>
                      ))}
                </Select>
                {errors.stateOrCountry && (
                  <FormHelperText>
                    {errors.stateOrCountry.message}
                  </FormHelperText>
                )}
              </FormControl>
            )}
            name="stateOrCountry"
            control={control}
            rules={{
              required:
                typeOfTeacherSelected === "International Teacher"
                  ? "Country is required"
                  : "State is required",
            }}
          />
        </div>
        {typeOfTeacherSelected === "International Teacher" && (
          <div className="mb-1">
            <div className="my-0-5">Facilities Required:</div>
            <Controller
              render={({ field }) => (
                <div>
                  <FormGroup>
                    <div className="flex flex-col">
                      {optionsFacilitiesForInternationals.map(
                        (facility, index) => (
                          <div className="flex flex-col">
                            <FormControlLabel
                              key={index}
                              onChange={(event) => {
                                const currentValue = field.value || []; // Inicializar como array vacío si es undefined
                                const selectedValues = event.target.checked
                                  ? [...currentValue, facility.title] // Si está marcado, agregamos el valor seleccionado
                                  : currentValue.filter(
                                      (value) => value !== facility.title
                                    ); // Si está desmarcado, eliminamos el valor seleccionado
                                field.onChange(selectedValues);
                              }}
                              checked={(field.value || []).includes(
                                facility.title
                              )} // Verificar si el valor está en los seleccionados
                              value={facility.title}
                              control={<Checkbox />}
                              label={
                                <div className="flex flex-col sm:flex-row sm:items-center">
                                  <div>{facility.title} </div>
                                  <span className="text-xs hidden sm:flex ml-0-5">
                                    {facility.note}
                                  </span>
                                </div>
                              }
                            />
                            <span className="text-xs mb-0-5 sm:hidden">
                              {facility.note}
                            </span>
                          </div>
                        )
                      )}
                    </div>
                  </FormGroup>
                </div>
              )}
              name="facilitiesForInternationals"
              control={control}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonalDetails;
